// @ts-strict-ignore
import type { TypographyObject } from "types/contentful";
import type {
  DevicesObject,
  FontWeightOption,
  TextAlignOption
} from "./common";

export interface TypographyObjectProps {
  textAlign?: DevicesObject<TextAlignOption>;
  color?: DevicesObject;
  fontSize?: DevicesObject;
  background?: DevicesObject;
  maxWidth?: DevicesObject;
  margin?: DevicesObject;
  padding?: DevicesObject;
  inset?: DevicesObject;
  letterSpacing?: DevicesObject;
  lineHeight?: DevicesObject;
  fontWeight?: DevicesObject<FontWeightOption>;
  fontFamily?: DevicesObject;
}

export const typographyObjectDefaults: TypographyObjectProps = {
  textAlign: {
    mobile: "left",
    tablet: "left",
    desktop: "left"
  },
  color: {
    mobile: "",
    tablet: "",
    desktop: ""
  },
  fontSize: {
    mobile: "",
    tablet: "",
    desktop: ""
  },
  background: {
    mobile: "",
    tablet: "",
    desktop: ""
  },
  maxWidth: {
    mobile: "",
    tablet: "",
    desktop: ""
  },
  margin: {
    mobile: "",
    tablet: "",
    desktop: ""
  },
  padding: {
    mobile: "",
    tablet: "",
    desktop: ""
  },
  inset: {
    mobile: "",
    tablet: "",
    desktop: ""
  },
  letterSpacing: {
    mobile: "",
    tablet: "",
    desktop: ""
  },
  lineHeight: {
    mobile: "",
    tablet: "",
    desktop: ""
  },
  fontWeight: {
    mobile: "normal",
    tablet: "normal",
    desktop: "normal"
  },
  fontFamily: {
    mobile: "",
    tablet: "",
    desktop: ""
  }
};

export const contentfulTypograpyObjectToTypography = (
  contentfulObject: TypographyObject,
  device: "mobile" | "tablet" | "desktop"
) =>
  Object.keys(typographyObjectDefaults).reduce(
    (acc, cssProperty) =>
      contentfulObject?.fields?.[cssProperty]
        ? {
            ...acc,
            [cssProperty]: { [device]: contentfulObject?.fields?.[cssProperty] }
          }
        : acc,
    {}
  );
